<template>
    <div class="panel bonus-list no-title">
      <div class="title" v-if="!isMobile">Alınabilir Bonuslar</div>
      <div class="content">
          <div class="alert" v-if="_.isEmpty(receivable)">
            Sonuç Bulunamadı
          </div>
          <div class="item" v-for="(item,key) in receivable" :key="key">
            <div class="image">
              <img width="150" :src="$store.state.main.cdn_url + item.promotion.banner">
            </div>
            <div class="info">
              <h5>{{ item.title }}</h5>
              <p>{{ $t(item.type_name) }}</p>
              <div class="buttons">
                <button class="button secondary" @click="open(item)">Detaylar</button>
                <ButtonLoader @click.native="$parent.make(item.bonus_id)" v-if="item.limits.auto_bonus == 1" class="primary" :loader="btnLoading" :text="'Bonusu Al'" />
                <div class="button label" v-if="!isMobile">Min. Çevrim Oranı: {{ item.min_rate }}</div>
                <div class="button label" v-if="!isMobile">Çevrim Katı: {{ item.coefficient }}</div>
              </div>
            </div>
          </div>
      </div>
    </div>
</template>
<script>
  export default{
    props:['receivable','btnLoading'],
    data(){
      return{
        
      }
    },
    methods:{
      open(val){
        this.$emit('openBonus', val);
      }
    }
  }
</script>
<style>
  button svg{
    width: 14px;
    height: 14px;
  }
</style>